import { useState, useEffect } from "react";
import { Edit, Trash2, Search } from "lucide-react";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_ORIGO_BASE_URL;

const Measurement = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [userDefinedCount, setUserDefinedCount] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const rowLimitOptions = [25, 50, 100];
  const [editModal, setEditModal] = useState({ show: false, id: null, title: "", original_title:"" });
  const [deleteModal, setDeleteModal] = useState({ show: false, id: null, title:"", original_title:'' });
  const [sortField, setSortField] = useState('original_title');
  const [sortDirection, setSortDirection] = useState('ASC');

  // ✅ Token uthao localStorage se
  const getToken = () => localStorage.getItem("origo_access_token");

  // ✅ Fetch sensors
  const fetchData = async (sortField, sortDirection) => {
    try {
      const token = getToken();
      if (!token) {
        console.error("No token found, please login again.");
        return;
      }

      const headers = { Authorization: `Bearer ${token}` };
      let url = `${BASE_URL}config/sensors`;

      if (searchTerm.trim()) {
        url += `?page=${page}&limit=${limit}&keyword=${encodeURIComponent(searchTerm)}&sortBy=[["${sortField}","${sortDirection}"]]`;
      } else {
        url += `?page=${page}&limit=${limit}&sortBy=[["${sortField}","${sortDirection}"]]`;
      }

      const res = await axios.get(url, { headers });
      setData(res.data?.data?.sensorsData || []);
      setTotalCount(res.data?.data?.totalCount || 0);
      setUserDefinedCount(res.data?.data?.userDefinedCount || 0);
    } catch (err) {
      console.error("Error fetching sensors:", err.response?.data || err);
    }
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'ASC' ? 'DESC' : 'ASC');
    } else {
      setSortField(field);
      setSortDirection('ASC');
    }

    // fetchData(field, sortDirection === 'ASC' ? 'ASC' : 'DESC');

    // const sortedData = [...data].sort((a, b) => {
    //   let aValue = a[field] || '';
    //   let bValue = b[field] || '';

    //   if (field === 'updatedAt') {
    //     aValue = new Date(aValue);
    //     bValue = new Date(bValue);
    //   }

    //   if (sortDirection === 'ASC') {
    //     return aValue > bValue ? 1 : -1;
    //   } else {
    //     return aValue < bValue ? 1 : -1;
    //   }
    // });

    // setData(sortedData);
  };

  useEffect(() => {
    fetchData(sortField, sortDirection);
  }, [page, searchTerm, limit, sortField, sortDirection]);

 // ✅ Edit
const handleEdit = async () => {
  try {
    const token = getToken();
    const headers = { Authorization: `Bearer ${token}` };

    await axios.put(
      `${BASE_URL}config/sensors/${editModal.id}`,
      { user_defined_title: editModal.title },
      { headers }
    );

    setEditModal({ show: false, id: null, title: "", original_title:"" });
    fetchData(sortField, sortDirection); // refresh
  } catch (err) {
    console.error("Edit failed:", err.response?.data || err);
  }
};

  // ✅ Delete
  const handleDelete = async (id) => {
    try {
      const token = getToken();
      const headers = { Authorization: `Bearer ${token}` };
  
      await axios.put(
        `${BASE_URL}config/sensors/${id}`,
        {
          user_defined_title: null  
        },
        { headers }
      );
  
      setDeleteModal({ show: false, id: null, title:"" });
      fetchData(sortField, sortDirection); // refresh table after delete
    } catch (err) {
      console.error("Delete failed:", err.response?.data || err);
    }
  };
  


  const ActionButtons = ({ id, currentTitle, original_title }) => (
    <div className="flex gap-4">
      <button
        className="btn btn-ghost btn-sm p-1"
        onClick={() => setEditModal({ show: true, id, title: currentTitle || "", original_title: original_title || "" })}
      >
        <Edit size={16} className="text-black dark:text-white" />
      </button>
      <button
        className="btn btn-ghost btn-sm p-1"
        disabled={!currentTitle}
        onClick={() => setDeleteModal({ show: true, id, title: currentTitle, original_title })}
      >
        <Trash2 disabled={!currentTitle} size={16} className="text-black dark:text-white disabled:text-opacity-50 disabled:dark:text-opacity-50"/>
      </button>
    </div>
  );

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg p-4 flex flex-col gap-4 h-full overflow-hidden">
      {/* Header with title and stats */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <h2 className="text-base font-semibold text-black dark:text-white">
          Unique List of Measurement
        </h2>
        <div className="flex items-center gap-4">
          <div className="bg-[#DBDBDB80] h-12 w-[1px]"></div>
          <div className="text-xs text-[##3A3737BF]">
            Total User-Defined <br /> /Unique
          </div>
          <span className="text-[#0000E0] bg-[#D0D0FF] p-2 rounded font-medium">
            {userDefinedCount}/{totalCount}
          </span>
          <div className="bg-[#DBDBDB80] h-12 w-[1px]"></div>
          <div className="border-[#F8F8F8] dark:border-gray-700 border-b px-6 py-3.5 flex gap-2 items-center w-full sm:w-auto">
            <Search size={16} className="text-gray-400 dark:text-gray-500" />
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => {
                setPage(1);
                setSearchTerm(e.target.value);
              }}
              className="input input-ghost input-xs w-full sm:w-64 font-thin text-[#747474] dark:text-gray-300 placeholder:text-xs dark:placeholder:text-gray-500 focus:outline-none dark:bg-gray-800 dark:focus:text-white"
            />
          </div>
        </div>
      </div>


      {/* Table Container with horizontal scroll */}
      <div className="overflow-x-auto flex-1 overflow-y-auto border border-gray-200 dark:border-gray-700 rounded-lg">
        <div className="min-w-[800px]">
          <table className="w-full">
            <thead className="sticky top-0 bg-gray-50 dark:bg-gray-900 z-10">
              <tr className="border-b border-gray-200 dark:border-gray-700 text-xs text-[#3A3737] dark:text-gray-300 font-medium">
                <th 
                  className="py-4 px-6 text-left whitespace-nowrap cursor-pointer select-none"
                  onClick={() => handleSort('original_title')}
                >
                  <div className="flex items-center gap-2 justify-between">
                    Original Title
                    <span className="text-gray-600 dark:text-gray-400 flex items-center gap-1">
                      {sortField === 'original_title' ? (
                        sortDirection === 'ASC' ? (
                          <span className="flex items-center">
                            A-Z <span className="text-xl ml-1">↑</span>
                          </span>
                        ) : (
                          <span className="flex items-center">
                            Z-A <span className="text-xl ml-1">↓</span>
                          </span>
                        )
                      ) : (
                        <span className="text-lg">↕</span>
                      )}
                    </span>
                  </div>
                </th>
                <th 
                  className="py-4 px-6 text-left whitespace-nowrap cursor-pointer select-none"
                  onClick={() => handleSort('user_defined_title')}
                >
                  <div className="flex items-center gap-2 justify-between">
                    User-defined Title
                    <span className="text-gray-600 dark:text-gray-400 flex items-center gap-1">
                      {sortField === 'user_defined_title' ? (
                        sortDirection === 'ASC' ? (
                          <span className="flex items-center">
                            A-Z <span className="text-xl ml-1">↑</span>
                          </span>
                        ) : (
                          <span className="flex items-center">
                            Z-A <span className="text-xl ml-1">↓</span>
                          </span>
                        )
                      ) : (
                        <span className="text-lg">↕</span>
                      )}
                    </span>
                  </div>
                </th>
                <th 
                  className="py-4 px-6 text-left whitespace-nowrap cursor-pointer select-none"
                  onClick={() => handleSort('updated_at')}
                >
                  <div className="flex items-center gap-2 justify-between">
                    Updated On
                    <span className="text-gray-600 dark:text-gray-400 flex items-center gap-1">
                      {sortField === 'updated_at' ? (
                        sortDirection === 'ASC' ? (
                          <span className="flex items-center">
                            Old-New <span className="text-xl ml-1">↑</span>
                          </span>
                        ) : (
                          <span className="flex items-center">
                            New-Old <span className="text-xl ml-1">↓</span>
                          </span>
                        )
                      ) : (
                        <span className="text-lg">↕</span>
                      )}
                    </span>
                  </div>
                </th>
                <th className="py-4 px-6 text-left whitespace-nowrap">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="text-sm">
              {data.map((item) => (
                <tr
                  key={item.id}
                  className="border-b border-gray-100 dark:border-gray-700 dark:text-gray-300"
                >
                  <td className="py-4 px-6 whitespace-nowrap">
                    {item.original_title}
                  </td>
                  <td className="py-4 px-6 whitespace-nowrap">
                    {item.user_defined_title || (
                      <span className="text-gray-400 dark:text-gray-500">-</span>
                    )}
                  </td>
                  <td className="py-4 px-6 whitespace-nowrap">
                    {item.updated_at
                      ? new Date(item.updated_at).toLocaleDateString('en-GB')
                      : "-"}
                  </td>
                  <td className="py-4 px-6 whitespace-nowrap">
                    <ActionButtons
                      id={item.id}
                      currentTitle={item.user_defined_title}
                      original_title={item.original_title}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination */}
      {(
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 px-6 py-4 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 rounded-b-lg">
          <div className="flex items-center gap-4">
            <div className="text-sm text-[#747474] dark:text-gray-400">
              Rows per page:
              <select
                value={limit}
                onChange={(e) => {
                  setLimit(Number(e.target.value));
                  setPage(1);
                }}
                className="ml-2 select select-bordered select-sm bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 border-gray-300 dark:border-gray-700"
              >
                {rowLimitOptions.map(opt => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </select>
            </div>
            <span className="text-sm text-[#747474] dark:text-gray-400">
              {(page - 1) * limit + 1} - {Math.min(page * limit, totalCount)} of {totalCount} records
            </span>
          </div>
          <div className="flex items-center gap-2">
            <button
              className={`px-4 py-1 rounded ${
                page === 1 
                  ? "bg-gray-200 text-gray-500 cursor-not-allowed" 
                  : "bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200"
              }`}
              onClick={() => page > 1 && setPage(page - 1)}
              disabled={page === 1}
            >
              Previous
            </button>
            <button
              className={`px-4 py-1 rounded ${
                page >= Math.ceil(totalCount / limit) 
                  ? "bg-gray-200 text-gray-500 cursor-not-allowed" 
                  : "bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200"
              }`}
              onClick={() => page < Math.ceil(totalCount / limit) && setPage(page + 1)}
              disabled={page >= Math.ceil(totalCount / limit)}
            >
              Next
            </button>
          </div>
        </div>
      )}

      {editModal.show && (
        <dialog className="modal modal-open">
          <div className="modal-box bg-white dark:bg-gray-800">
            <h3 className="font-medium text-lg text-gray-900 dark:text-gray-100">
              Change Measurement Label
            </h3>
            <p className="text-xs font-normal text-gray-600 dark:text-gray-300 mt-2">
              Please provide a custom name for this {editModal.original_title} measurement to ensure clear identification and better organization.
            </p>
            <div className="py-4">
              <input
                type="text"
                placeholder="Enter new title"
                value={editModal.title}
                onChange={(e) => setEditModal(prev => ({ ...prev, title: e.target.value }))}
                className="input input-bordered w-full bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 font-normal"
              />
            </div>
            <div className="modal-action justify-start gap-1 mt-1">
              <button
                className="btn bg-blue-600 hover:bg-blue-700 text-white border-none rounded-full px-4 py-1 capitalize text-sm font-normal h-auto min-h-max"
                onClick={handleEdit}
              >
                Update
              </button>
              <button
                className="btn btn-outline bg-gray-300 border-none dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:hover:bg-gray-700 rounded-full px-4 py-1 capitalize text-sm font-normal h-auto min-h-max"
                onClick={() => setEditModal({ show: false, id: null, title: "", original_title:"" })}
              >
                Cancel
              </button>
            </div>
          </div>
          <form method="dialog" className="modal-backdrop">
            <button onClick={() => setEditModal({ show: false, id: null, title: "", original_title:"" })}>
              close
            </button>
          </form>
        </dialog>
      )}

      {deleteModal.show && (
        <dialog className="modal modal-open">
          <div className="modal-box bg-white dark:bg-gray-800">
            <h3 className="font-medium text-lg text-gray-900 dark:text-gray-100">
              Revert To Default
            </h3>
            <p className="text-xs font-normal text-gray-600 dark:text-gray-300 mt-2">
              Are you sure you want to delete this measurement's User defined title? This action cannot be undone
            </p>
            <p className="text-xs font-normal text-gray-600 dark:text-gray-300 mt-3 mb-1"><span className="font-semibold">Measurement:</span> {deleteModal.original_title}</p>
            <p className="text-xs font-normal text-gray-600 dark:text-gray-300"><span className="font-semibold">User Defined Title:</span> {deleteModal.title || <span className="text-gray-400 dark:text-gray-500">-</span>}</p>

            <div className="modal-action justify-end gap-1 mt-6">
              <button
                className="btn bg-red-600 hover:bg-red-700 text-white border-none rounded-full px-4 py-1 capitalize text-sm font-normal h-auto min-h-max"
                onClick={() => handleDelete(deleteModal.id)}
              >
                Delete
              </button>
              <button
                className="btn btn-outline bg-gray-300 border-none dark:bg-slate-200 dark:border-gray-600 dark:text-black dark:hover:bg-gray-700 rounded-full px-4 py-1 capitalize text-sm font-normal h-auto min-h-max"
                onClick={() => setDeleteModal({ show: false, id: null, title:"", original_title:"" })}
              >
                Cancel
              </button>
            </div>
          </div>
          <form method="dialog" className="modal-backdrop">
            <button
              className="cursor-default"
              onClick={() => setDeleteModal({ show: false, id: null, title:"", original_title:'' })}
            >
              close
            </button>
          </form>
        </dialog>
      )}

    </div>
  );
};

export default Measurement;
